import {Schema} from "effect";

export {FollowWriteError, FollowAuthError, FollowWriteOperation} from "./errors.js";
export type {FollowError, FollowWriteOperation as FollowWriteOperationType} from "./errors.js";

/**
 * Firestore collection backing follow relationships. Reads are client-side
 * `onSnapshot` subscriptions; writes go through the accounts-app HTTP endpoint.
 */
export const FOLLOWERS_COLLECTION = "accountFollowers";

/** Deterministic doc id for a (followed, follower) pair. Must match `createFollowerDocumentUid`. */
export function followerDocId(followedUid: string, followerUid: string): string {
    return `${followedUid}:${followerUid}`;
}

export const FollowAccountType = Schema.Literal("user", "organization");
export type FollowAccountType = typeof FollowAccountType.Type;

export const FollowState = Schema.Literal("follow", "unfollow");
export type FollowState = typeof FollowState.Type;

export class FollowRequest extends Schema.Class<FollowRequest>("FollowRequest")({
    state: FollowState,
    accountUid: Schema.String,
    accountType: FollowAccountType,
}) {}

export class FollowResponse extends Schema.Class<FollowResponse>("FollowResponse")({
    following: Schema.Boolean,
}) {}
